function resizeFile(filePath, width, height, size) {
	const promise = new Promise(function(res, rej) {
		if (!document || !document.createElement) {
			rej()
		} else {
			const canvas = document.createElement('canvas')
			canvas.width = width
			canvas.height = height
			const ctx = canvas.getContext('2d')
			ctx.fillStyle = '#ffffff'
			ctx.rect(0, 0, width, height)
			ctx.fill()
			const img = document.createElement('img')
			img.setAttribute('crossorigin', 'Anonymous')
			img.onload = function() {
				const imgW = img.width
				const imgH = img.height
				const imgRel = imgW/imgH
				const canvasRel = width/height
				let destW, destH
				if ((imgRel > canvasRel && size === 'contain') || (imgRel < canvasRel && size === 'cover')) {
					destW = width
					destH = imgH * width / imgW
				} else {
					destW = imgW * height / imgH
					destH = height
				}
				const destX = -(destW - width) / 2
				const destY = -(destH - height) / 2
				ctx.drawImage(img, destX, destY, destW, destH)
				const imageData = canvas.toDataURL('image/png')
				res(imageData)
			}
			img.src = filePath
		}
	})
	return promise
}

export default resizeFile
